import { Component, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NavController, NavParams, LoadingController } from 'ionic-angular';
import { MenuServices } from "../../services";
import { MenuPageCustomizeTemplatPage } from "./menu-page-customize-template/menu-page-customize-template";
import { MenuPageCustomizeSeparatorsPage } from "./menu-page-customize-separators/menu-page-customize-separators";
import { MenuCreateDishSelectPage } from "../../menu-create/menu-create-dish-select/menu-create-dish-select";
import { Globals } from "../../../../globals";
import { MenuPartialCustomizeViewA5Page } from "../menu-partial-customize-view/menu-partial-customize-view-a5/menu-partial-customize-view-a5";
import { ConfigurationImagesPage } from "../../../configuration/configuration-images/configuration-images";
import { ConfigurationServices } from "../../../configuration/services";
import { CurrencyPipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { QRServices } from '../../../services/qrServices';



/**
 * Generated class for the MenuPartialCustomizeOptionsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-menu-partial-customize-options',
  templateUrl: 'menu-partial-customize-options.html',
})
export class MenuPartialCustomizeOptionsPage {

  @Input() menu_uid: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public menuServices: MenuServices,
    public globals: Globals,
    public configurationServices: ConfigurationServices,
    private http: HttpClient,
    private cp: CurrencyPipe,
    public loadingCtrl: LoadingController,
    public translate: TranslateService,
    public qrServices: QRServices) {


  }

  async captureScreen() {
    this.globals.GAtrackView('Menu', 'Menu - print A4', this.globals.restaurant.email, 'View', 'Print A4', 'Menu', '');



    if (this.globals.tour != '') {
      this.globals.GAtrackView('Tour', 'Tour - Menu - Finish ', this.globals.restaurant.email, 'Finish', 'Tour menu finish', 'Tour', 'Menu');
      this.globals.tour_step_user = -1;
      this.globals.tour = null;
    }


    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-imprimiendo-menu')
    });
    loadingPopup.present();

    //Format values
    var price_format = this.cp.transform(this.menuServices.menu_tmp.price, this.globals.user_currency, true, '0.2-2', 'es')
    var logo_format;

    if (!this.globals.logo_url) {
      logo_format = '';
    } else {
      await this.globals.logo_url.subscribe(data => {
        logo_format = data;
      });
    }

    //Watermark comprovation
    var watermark = 'false';
    if (this.globals.checkLimitsByLicense('menus', 'watermark')) {
      watermark = 'true';
    }

    //Format object menu for POST send
    var menu_send = this.menuServices.menu_tmp;
    this.http.post(this.globals.api_path + 'menu/a4',
      {
        menu: menu_send,
        price_format: price_format,
        logo: logo_format,
        lang: this.menuServices.menu_lang,
        watermark: watermark,
        tax: this.globals.user_tax_name,
      }
      , {})
      .subscribe(res => {
        if (this.globals.so_mobile) {
          window.location.assign(String(res['file']));
        } else {
          window.open(String(res['file']), '_blank');
        }
        loadingPopup.dismiss();
      }, error => {
        loadingPopup.dismiss();
      });

  }

  async a5() {

    /*
    * Crearemos una api en laravel para la impression en pdf de los menus.
    * */

    this.globals.GAtrackView('Menu', 'Menu - A5', this.globals.restaurant.email, 'View', 'Print A5', 'Menu', '');

    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-imprimiendo-menu')
    });
    loadingPopup.present();

    //Format values
    var price_format = this.cp.transform(this.menuServices.menu_tmp.price, this.globals.user_currency, true, '0.2-2', 'es')
    var logo_format;

    if (!this.globals.logo_url) {
      logo_format = '';
    } else {
      await this.globals.logo_url.subscribe(data => {
        logo_format = data;
      });
    }

    //Watermark comprovation
    var watermark = 'false';
    if (this.globals.checkLimitsByLicense('menus', 'watermark')) {
      watermark = 'true';
    }


    //Format object menu for POST send
    var menu_send = this.menuServices.menu_tmp;
    this.http.post(this.globals.api_path + 'menu/a5',
      {
        menu: menu_send,
        price_format: price_format,
        logo: logo_format,
        lang: this.menuServices.menu_lang,
        watermark: watermark,
        tax: this.globals.user_tax_name,
      }, {})
      .subscribe(res => {
        if (this.globals.so_mobile) {
          window.location.assign(String(res['file']));
        } else {
          window.open(String(res['file']), '_blank');
        }
        loadingPopup.dismiss();
      }, error => {
        loadingPopup.dismiss();
      });

  }


  async updateIonToggle(type, value) {
    switch (type) {
      case 'enumerate': {
        await this.menuServices.afs.collection('menus').doc(this.menu_uid).update({
          'enumerate': value,
        });
        break;
      }
      case 'logo_show': {
        await this.menuServices.afs.collection('menus').doc(this.menu_uid).update({
          'logo_show': value,
        });
        break;
      }
      case 'caption_show': {
        await this.menuServices.afs.collection('menus').doc(this.menu_uid).update({
          'caption_show': value,
        });
        break;
      }
      case 'footer_show': {
        await this.menuServices.afs.collection('menus').doc(this.menu_uid).update({
          'footer_show': value,
        });
        break;
      }
      case 'section_show': {
        await this.menuServices.afs.collection('menus').doc(this.menu_uid).update({
          'section_show': value,
        });
        break;
      }

    }
  }

  openTemplates() {
    this.navCtrl.push(MenuPageCustomizeTemplatPage, {
      menu_uid: this.menu_uid
    })

  }

  openSeparators() {
    this.navCtrl.push(MenuPageCustomizeSeparatorsPage, {
      menu_uid: this.menu_uid
    })
  }

  openNewSection() {

    this.navCtrl.push(MenuCreateDishSelectPage, {
      type: this.menuServices.menu_tmp.style,
      section: Object.keys(this.menuServices.menu_tmp.sections).length,
      section_complete: this.menuServices.menu_tmp.sections,
      update: true,
      menu_uid: this.menu_uid,
      menu: this.menuServices.menu_tmp,
      new: true,
    });

  }

  printA5() {
    this.navCtrl.push(MenuPartialCustomizeViewA5Page);
  }

  openLogo() {
    this.globals.side_menu_config_active = 'images';
    this.navCtrl.push(ConfigurationImagesPage);
  }

  async share() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-compartiendo-carta')
    });
    loadingPopup.present();

    //Format values
    var price_format = this.cp.transform(this.menuServices.menu_tmp.price, this.globals.user_currency, true, '0.2-2', 'es')
    var logo_format;

    if (!this.globals.logo_url) {
      logo_format = '';
    } else {
      await this.globals.logo_url.subscribe(data => {
        logo_format = data;
      });
    }

    //Watermark comprovation
    var watermark = 'false';
    if (this.globals.checkLimitsByLicense('menus', 'watermark')) {
      watermark = 'true';
    }

    this.globals.GAtrackView('Menu', 'Menu - Share', this.globals.restaurant.email, 'View', 'Share menu', 'Menu', '');

    //Format object menu for POST send
    var menu_send = this.menuServices.menu_tmp;
    this.http.post(this.globals.api_path + 'menuxxss',
      {
        menu: menu_send,
        price_format: price_format,
        logo: logo_format,
        lang: this.menuServices.menu_lang,
        watermark: watermark,
        tax: this.globals.user_tax_name,
      }, {})
      .subscribe(res => {
        window.open(this.globals.api_path + 'share/daily-menu/' + String(res['file']) + '/' + this.menuServices.menu_lang);
        loadingPopup.dismiss();
      }, error => {
        loadingPopup.dismiss();
      });

  }

  changeLang(lang) {
    this.menuServices.menu_lang = lang;
  }

  async generateGR() {
    //this.qrServices.generateMenuCartaGR();
  }




}



// WEBPACK FOOTER //
// ./src/pages/menu/menu-view/menu-partial-customize-options/menu-partial-customize-options.ts